import React, { useState, useEffect } from 'react';
import Header from '../components/Common/Header';
import BiharElectionNews from '../components/Public/BiharElectionNews';
import './News.css';

const NewsPage = () => {
  const [connectionStatus, setConnectionStatus] = useState({ 
    connected: true, 
    message: 'Connected' 
  });

  return (
    <div className="news-page">
      <Header connectionStatus={connectionStatus} />
      <main className="news-page-main">
        <BiharElectionNews />
      </main>
      {/* <footer className="news-page-footer">
        <p>&copy; 2025 Bihar Election Tracker. All rights reserved.</p>
      </footer> */}
    </div>
  );
};

export default NewsPage;
